/**
 * Handles cross-tab communication for cart events
 */
class CartSessionManager {
  /** Shared channel between browser tabs */
  channel = new BroadcastChannel('cart-session');
  listeners = [];

  constructor() {
    // Listen for messages from other tabs
    this.channel.onmessage = (event) => {
      const { type, tabId } = event.data;

      // Notify listeners when a cart is opened in another tab
      if (type === 'CART_OPENED') {
        this.listeners.forEach((cb) => cb(tabId));
      }
    };
  }

  /**
   * Generates a unique ID for the current tab
   * @returns {string}
   */
  generateTabId() {
    return crypto.randomUUID();
  }

  /**
   * Notifies other tabs that a cart was opened
   * @param {string} tabId - Unique tab identifier
   * @returns {void}
   */
  notifyCartOpened(tabId) {
    this.channel.postMessage({ type: 'CART_OPENED', tabId });
  }

  /**
   * Subscribes to CART_OPENED events
   * @param {(tabId: string) => void} callback - Listener function
   * @returns {() => void} Unsubscribe function
   */
  onCartOpened(callback) {
    this.listeners.push(callback);

    return () => {
      this.listeners = this.listeners.filter((cb) => cb !== callback);
    };
  }

  /**
   * Subscribes to a specific localStorage key change
   * @param {string} key
   * @param {(newValue: string | null, oldValue: string | null) => void} callback
   * @returns {() => void}
   */
  onCustomerChanged(key, callback) {
    const handler = (event) => {
      if (event.key !== key) return;

      callback(event.newValue, event.oldValue);
    };

    window.addEventListener('storage', handler);

    return () => {
      window.removeEventListener('storage', handler);
    };
  }
}

export default new CartSessionManager();
